"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentNode = exports.ContentNodeDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var markdown_1 = require("../elements/markdown");
var content_title_1 = require("../elements/content-title");
var truncate_words_1 = require("../../utils/truncate-words");
var badge_divider_1 = require("../elements/badge-divider");
var use_lang_1 = require("../../hooks/use-lang");
exports.ContentNodeDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n\n    ", "\n\n\n  "], ["\n    font-size: 1em;\n\n    ", "\n\n\n  "])), function (_a) {
    var maxLines = _a.maxLines;
    return maxLines && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    "], ["\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    "])), maxLines);
  })
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", "em;\n    margin-bottom: 0.5em;\n  "], ["\n    font-size: ", "em;\n    margin-bottom: 0.5em;\n  "])), 16 / 15)
});
var MoreStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    cursor: pointer;\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    .shp-badge-divider__badge {\n      color: ", ";\n      text-transform: uppercase;\n    }\n\n    &:hover {\n      color: ", ";\n\n      .shp-badge-divider__badge {\n        border-color: ", ";\n      }\n    }\n  "], ["\n    cursor: pointer;\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    .shp-badge-divider__badge {\n      color: ", ";\n      text-transform: uppercase;\n    }\n\n    &:hover {\n      color: ", ";\n\n      .shp-badge-divider__badge {\n        border-color: ", ";\n      }\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.section(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: (0, styled_components_1.default)(markdown_1.Markdown)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  More: (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MoreStyles)
};
var ContentNode = function (props) {
  var className = props.className,
    entity = props.entity,
    title = props.title,
    maxLines = props.maxLines,
    maxWords = props.maxWords,
    markdown = __rest(props, ["className", "entity", "title", "maxLines", "maxWords"]);
  var showMoreButton = props.showMoreButton === undefined ? !!maxWords : props.showMoreButton;
  var _a = __read((0, react_1.useState)(false), 2),
    isExpanded = _a[0],
    setIsExpanded = _a[1];
  var t = (0, use_lang_1.useLang)();
  if (!entity) {
    return null;
  }
  var text = entity.text && entity.text.replace(/\\/ig, '');
  var hasText = !!text;
  if (!hasText) {
    return null;
  }
  var textToShow = maxWords && !isExpanded ? (0, truncate_words_1.truncateWords)(text, {
    max: maxWords
  }) : text;
  var hasMore = textToShow !== text;
  return react_1.default.createElement(My.Container, {
    className: className
  }, title && react_1.default.createElement(My.Title, null, title), react_1.default.createElement(My.Content, __assign({}, markdown, {
    embeds: entity.embeds,
    atEmbeds: entity.atEmbeds,
    linkEmbeds: entity.linkEmbeds,
    linkRichEmbeds: entity.linkRichEmbeds,
    maxLines: maxLines,
    text: textToShow
  })), hasMore && showMoreButton && !isExpanded && react_1.default.createElement(My.More, {
    lineVariant: 'dotted',
    onClick: function () {
      setIsExpanded(true);
      if (props.onExpand) {
        props.onExpand();
      }
    }
  }, t('Read More')));
};
exports.ContentNode = ContentNode;
exports.ContentNode.defaultProps = exports.ContentNodeDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;